import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
/**
 *  * The Item Card is an adaptive layout component.
 *  The props supplied to sideBar, header, footer, body left and right will render in the appropriate containers
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ItemCard(_ref) {
  let {
    className,
    body,
    sideBar,
    header,
    footer,
    uiContext,
    orientation,
    ...rest
  } = _ref;
  // Deprecate but still respect uiContext
  if (uiContext && !orientation) {
    orientation = uiContext;
  }
  const rootClassName = clsx({
    row: uiContext !== 'alpha',
    'item-card': true,
    'display-flex': true,
    'align-items-stretch': uiContext !== 'alpha',
    'flex-grow-1': uiContext !== 'alpha',
    'flex-column': orientation === 'portrait' || uiContext === 'snapshot'
  }, className);
  const sideBarClassName = clsx({
    'alpha-sidebar': orientation !== 'portrait' && uiContext === 'alpha',
    'col-sm-4': !orientation && uiContext !== 'alpha',
    'col-xs-4 display-flex justify-content-center align-items-center': orientation === 'landscape' && uiContext !== 'alpha',
    'col-xs-12 justify-content-center': orientation === 'portrait' && uiContext !== 'alpha',
    'item-card-side': true
  });
  const contentClassName = clsx({
    'col-sm-8': !orientation && uiContext !== 'alpha',
    'col-xs-8': orientation === 'landscape' && uiContext !== 'alpha' && sideBar,
    'col-xs-12': (orientation === 'portrait' || !sideBar) && uiContext !== 'alpha',
    'item-card-content': true,
    'display-flex': true,
    'flex-column': true,
    'flex-grow-1': true,
    'justify-content-between': true,
    'padding-bottom-2': orientation === 'portrait' && uiContext !== 'alpha',
    'overflow-hidden': orientation === 'landscape'
  });
  return /*#__PURE__*/_jsxs("div", {
    "data-cmp": "itemCard",
    ...rest,
    className: rootClassName,
    children: [sideBar && /*#__PURE__*/_jsx("div", {
      className: clsx(sideBarClassName),
      children: sideBar
    }, "item-card-sidebar"), (header || body || footer) && /*#__PURE__*/_jsxs("div", {
      className: contentClassName,
      children: [header && /*#__PURE__*/_jsx("div", {
        className: "item-card-header",
        children: header
      }, "item-card-header"), body && /*#__PURE__*/_jsx("div", {
        className: "item-card-body margin-bottom-auto",
        children: body
      }, "item-card-body"), footer && /*#__PURE__*/_jsx("div", {
        className: "item-card-footer margin-top-auto",
        children: footer
      }, "item-card-footer")]
    })]
  }, "item-card");
}
export default ItemCard;